import { v3get, v3http } from "./Fetchv3.js";
import { Test } from "./test/test";

export let apiv3 = {
	test: new Test()
};
if (location.hostname.indexOf("localhost") > -1) {
	// @ts-ignore
	window.apiv3 = apiv3;
}

// @ts-ignore
window.chrome ||= {};
// @ts-ignore
window.chrome.apiv3 = { ...apiv3, v3get, v3http };
